import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import * as React from "react";

import * as styles from "./QuerySearch.module.less";

type PropsQuerySearch = {
  initialValue?: string;
  onChange: (value: string) => void;
};

export const QuerySearch: React.FC<PropsQuerySearch> = ({
  initialValue = "",
  onChange,
}) => {
  const [value, setValue] = React.useState(initialValue);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };
  const handleClear = () => {
    setValue("");
    onChange("");
  };
  const handleSearch = () => {
    onChange(value || "");
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };
  return (
    <Input
      className={styles.search}
      value={value}
      allowClear
      maxLength={255}
      placeholder="Поиск"
      count={{ show: true, max: 255 }}
      onClear={handleClear}
      onKeyDown={handleKeyDown}
      addonAfter={
        <button type="button" className={styles.btn} onClick={handleSearch}>
          <SearchOutlined />
          Найти
        </button>
      }
      onChange={handleChange}
    />
  );
};
